import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Button, Spin, Input } from 'antd';
import { LeftOutlined, RightOutlined, SearchOutlined } from '@ant-design/icons';
import {
  changeRole,
  fetchAllUsers,
  findByUsernameOrEmail,
  resetUserData,
} from './CreateAdminAction';

const PAGE_SIZE = 5;
const SORT_FIELD = 'createdDate';
const SORT_ORDER = 'DESC';

const CreateAdmin = () => {
  const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [text, setText] = useState('');
  const [displayedUsers, setDisplayedUsers] = useState([]);

  const { fetching, users, userData, assignAdminData } = useSelector(
    (state) => state?.assignAdmin || {}
  );
  const { data } = useSelector((state) => state?.auth || {});
  const email = data?.email || localStorage.getItem('email');
  const success = assignAdminData.success ? assignAdminData.success : null;

  useEffect(() => {
    dispatch(resetUserData());
    dispatch(fetchAllUsers(page, PAGE_SIZE, SORT_FIELD, SORT_ORDER));
  }, [dispatch, page]);

  useEffect(() => {
    if (userData?.data && Object.keys(userData.data).length > 0) {
      setDisplayedUsers([userData.data]);
    } else if (users?.list) {
      setDisplayedUsers(users.list);
    } else {
      setDisplayedUsers([]);
    }
  }, [userData, users]);

  function handlePagination(direction) {
    setPage((prevPage) => {
      if (direction === 'next') return prevPage + 1;
      return Math.max(0, prevPage - 1);
    });
  }

  function handleAssign(row, action) {
    if (!row?.id) return;
    dispatch(changeRole(row.id, action)).then(() => {
      if (text.trim()) {
        dispatch(findByUsernameOrEmail(text.trim()));
      } else {
        dispatch(fetchAllUsers(page, PAGE_SIZE, SORT_FIELD, SORT_ORDER));
      }
    });
  }

  function handleSearch() {
    const query = text.trim();
    if (query) {
      dispatch(findByUsernameOrEmail(query));
    } else {
      dispatch(resetUserData());
      setPage(0);
    }
  }

  const columns = [
    { title: 'First Name', dataIndex: 'firstName', key: 'firstName' },
    { title: 'Last Name', dataIndex: 'lastName', key: 'lastName' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    {
      title: '',
      key: 'action',
      render: (_, row) => {
        const roles = Array.isArray(row.roles) ? row.roles : [];
        const isAdmin = roles.some((r) => r.id === 'role.admin');

        return (
          <Button
            disabled={row.email === email}
            danger={isAdmin}
            onClick={() => handleAssign(row, !isAdmin)}
          >
            {isAdmin ? 'Unassign' : 'Assign'}
          </Button>
        );
      },
    },
  ];

  const isNextDisabled = displayedUsers.length < PAGE_SIZE;

  return (
    <>
      <div className="space-listing-section">
        <div className="container">
          <h1 className="title">Assign Admin</h1>
          <p className="title">
            <Input
              className="search-input"
              placeholder="Email or User Name"
              value={text}
              onChange={(e) => setText(e.target.value)}
              onPressEnter={handleSearch}
            />
            <Button
              className="btn-search"
              type="primary"
              onClick={handleSearch}
              icon={<SearchOutlined />}
            >
              Search
            </Button>
          </p>
        </div>
      </div>

      <br />

      {fetching ? (
        <div className="spin-space-list">
          <Spin size="large" />
        </div>
      ) : (
        <div className="space-listing-section">
          <Table
            className="space-listing-table"
            dataSource={displayedUsers}
            columns={columns}
            rowKey="id"
            pagination={false}
            scroll={{ x: true, y: true }}
          />
          <br />
          <p className="pagination-wrap">
            <Button
              type="default"
              icon={<LeftOutlined />}
              onClick={() => handlePagination('prev')}
              disabled={page <= 0}
              style={{ marginRight: 8 }}
            />
            Page: {page + 1}
            <Button
              type="default"
              icon={<RightOutlined />}
              onClick={() => handlePagination('next')}
              disabled={isNextDisabled}
              style={{ marginLeft: 8 }}
            />
          </p>
        </div>
      )}
    </>
  );
};

export default CreateAdmin;
